module.exports = __webpack_public_path__ + "static/hero-image-desktop_b-5474ee843b9610b5a16c75ad15049fc4.webp";